<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'meteringpoint.identification' | translate }}</label>
    <input appInput formControlName="meteringPointIdentification" readonly>
  </app-input-group>
</form>
